import React from "react";
import { createRoot } from "react-dom/client";
import { initAnalytics } from "./analytics";
import { App } from "./ui/App";
import { registerServiceWorker } from "./registerServiceWorker";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

initAnalytics();
registerServiceWorker();
